import { Component } from '@angular/core';
import { FeedbackService } from '../../appshared/web/feedback/feedback.service';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from '../../shared/header/header.component';
import { FooterComponent } from '../../shared/footer/footer.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FeedbackModule } from '../../appshared/web/feedback/feedback.module';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contactus',
  standalone: true,
  imports: [
    TranslateModule,
    HeaderComponent,
    FooterComponent,
    FormsModule,
    CommonModule,
  ],
  templateUrl: './contactus.component.html',
  styleUrl: './contactus.component.css',
})
export class ContactusComponent {
  SelectedLanguage: string = localStorage.getItem('locale') || 'en';
  dir = this.SelectedLanguage === 'ar' ? 'rtl' : 'ltr';
  categoryData: any[] = [];
  currentLang = localStorage.getItem('locale') || 'en';
  isSubmitting = false;
  submitError: string | null = null;
  submitSuccess = false;

  constructor(private feedbackService: FeedbackService,
    private router: Router,
    private toastr: ToastrService) {}

  ngOnInit() {}

  submit(formValue: any) {
    if (this.isSubmitting) return;

    if (formValue.name.length < 5 || formValue.number.length < 5 || formValue.email.length < 5 || formValue.message.length < 5) {
      if (this.currentLang === 'en') {
        this.toastr.warning(`Please Fill All Data`);
      } else {
        this.toastr.warning(`الرجاء تعبئة كل البيانات`);
      }

    }


    this.isSubmitting = true;
    this.submitError = null;
    this.submitSuccess = false;

    const feedbackData: FeedbackModule = {
      wbFeedbackID: 0,
      name: formValue.name,
      phoneNo: formValue.number,
      email: formValue.email,
      message: formValue.message,
      addDate: new Date(),
      type: 'Consultation',
      notes: formValue.preferredDate || '',
      status: 'Waiting',
      gnCategoryID: 14,
      completedDate: '',
      completedByUserID: 0,
      dialing: '',
      mgCompanyID: 1,
    };

    this.feedbackService.postService(feedbackData).subscribe({
      next: (response) => {
        if (this.currentLang === 'en') {
          this.toastr.success(`Sent Successfully`);
        } else {
          this.toastr.success(`تم الارسال بنجاح`);
        }


        this.router.navigate(['/']);
      },
      error: (error) => {
        console.error('Submission failed:', error);
        this.submitError =
          'An error occurred while submitting the form. Please try again.';
      },
      complete: () => {
        this.isSubmitting = false;
      },
    });
  }
}
